
import React from 'react';

const RocketYellowUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='65'
			height='65'
			fill='none'
			viewBox='0 0 65 65'
		>
			<g fill='#FEE5B4' clipPath='url(#clip0)'>
				<path d='M54.485 9.487c-.2-.38-.5-.68-.86-.86-.48-.24-12-5.94-20.32 2.38l-4.98 4.96c-4.46-2.06-12.58-3.42-19.04 3.02-.78.78-.78 2.04 0 2.82l8 8 16 16 8 8c.4.4.9.58 1.42.58.52 0 1.02-.2 1.42-.58 6.44-6.44 5.08-14.58 3.04-19.04l4.96-4.96c8.42-8.4 2.6-19.84 2.36-20.32zm-29.24 9.56l-6.54 6.52-5.06-5.06c4.24-3.14 8.84-2.4 11.6-1.46zm17.36 30.42l-5.06-5.06.98-.98 5.54-5.54c.9 2.74 1.64 7.36-1.46 11.58zm6.68-22.48l-6 6-8.58 8.58-13.18-13.18 8.58-8.58 6-6c5.4-5.4 12.92-2.82 15.08-1.9.96 2.16 3.58 9.6-1.9 15.08zM18.125 32.994l-2.828 2.828L27.303 47.83 30.132 45 18.125 32.994z'></path>
				<path d='M40.705 16.407c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM13.3 38.984l-4.002 4.002 2.828 2.829 4.002-4.002-2.828-2.829zM21.3 46.984l-4.002 4.002 2.828 2.829 4.002-4.002-2.828-2.829zM17.29 42.994l-5.996 5.996 2.828 2.829 5.997-5.997-2.829-2.828zM50.705 60.5h-38v4h38v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(.5 .5)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default RocketYellowUnderline;
